module.exports = __webpack_public_path__ + "static/img/student_3.47ca5b14.png";